<template>
  <div class="card" @click="clickHandler">
    <div class="card--inner">
      <div class="card--front">
        <slot name="front"></slot>
      </div>
      <div class="card--back"><slot name="back"></slot></div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
import { useRouter, useRoute } from "vue-router";

const route = useRoute();
const props = defineProps(["details"]);
const router = useRouter();
function clickHandler() {
  if (route.path === "/minerals/filter") {
    return window.open(`${props.details}`);
  }
  router.push(props.details);
}
</script>

<style lang="css" scoped>
.card {
  perspective: 150rem;
  background-color: transparent;
  width: 20vw;
  height: 20vw;
  margin: 1rem;
}

@media only screen and (max-width: 51.25em) {
  /* 820px/16 */
  .card {
    width: 25vw;
    height: 25vw;
  }
}

@media only screen and (max-width: 37.5em) {
  /* 600px/16 */
  .card {
    width: 35vw;
    height: 35vw;
  }
}
@media only screen and (max-width: 28.7em) {
  /* 460px/16 */
  .card {
    width: 40vw;
    height: 40vw;
  }
}
@media only screen and (max-width: 20em) {
  /* 320px/16 */
  .card {
    width: 50vw;
    height: 50vw;
  }
}

.card--inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}
.card:hover .card--inner {
  transform: rotateY(180deg);
}
@media only screen and (max-width: 900px) {
  .card:hover .card--inner {
    transform: rotateY(0deg);
  }
}

.card--front,
.card--back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  padding: 1rem;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 2rem;
}

.card--front {
  background-color: white;
  display: grid;
  grid-template-rows: 90% 10%;
}

.front > :nth-child(1) {
  grid-row: 1/2;
}
.front > :nth-child(2) {
  grid-row: 2/3;
}

@media only screen and (max-width: 69em) {
  /* 1100px/16 */
  .card--front {
    grid-template-rows: 88% 12%;
  }
}

.card--back {
  background-color: white;
  transform: rotateY(180deg);
}
/** Mineral Card */
.mineralCard > .card--inner > .card--back {
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  position: relative;
  padding-top: 0.5rem;
}
@media only screen and (max-width: 81.25em) {
  .mineralCard > .card--inner > .card--back {
    display: none;
  }
}
</style>
